import './_navigationBar.scss'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'

import { type navigationBar } from 'types/types'

import ManageFeedButton from './Components/ManageFeedButton/ManageFeedButton'

import 'swiper/css'

// Safer than 1 (real list ids can be 1)
const PSEUDO_ALL_LIST_ID = 'all'

const NavigationBar = ({
    navArr,
    customClass,
    type,
    chosenListId,
    onApply,
    showManageFeed = false,
    listId,
    setListId
}: navigationBar) => {

    const location = useLocation()
    const { t } = useTranslation()


    const hasActiveItem =
        Array.isArray(navArr) &&
        typeof navArr[0] !== 'string' &&
        navArr.some((navItem: any) => navItem?.id === listId)

    return (
        <div
            className={`navbar navbar--${type} ${
                customClass ? `navbar__${customClass}` : ''
            }`}
        >
        <Swiper
            className="navbar__swiper"
            spaceBetween={5}
            slidesPerView="auto"
            resistanceRatio={0}
            threshold={5}
            watchOverflow={true}
            style={{ height: '100%' }}
        >
                {typeof navArr[0] === 'string' ? (
                    <>
                        {navArr.map((navItem: string, key: number) => {
                            // Normalize path
                            const targetPath = navItem.startsWith('/')
                                ? navItem
                                : `/settings/${navItem}`

                            const isActive =
                                location.pathname === targetPath ||
                                location.pathname.includes(navItem)

                            return (
                                <SwiperSlide key={key} style={{ width: 'auto' }}>
                                    <Link
                                        className={`navbar__link navbar--${type}__link--${
                                            isActive ? 'active' : 'inactive'
                                        }`}
                                        to={targetPath}
                                    >
                                        {t(navItem.split('/').pop() ?? 'Missing')}
                                    </Link>
                                </SwiperSlide>
                            )
                        })}
                    </>
                ) : (
                    <>
                        {/* Hardcoded ALL tab */}
                        <SwiperSlide key="all" style={{ width: 'auto' }}>
                            <div
                                tabIndex={0}
                                role="button"
                                className={`navbar__link navbar--${type}__link--${
                                    listId === PSEUDO_ALL_LIST_ID || !hasActiveItem
                                        ? 'active'
                                        : 'inactive'
                                } navbar__link--all`}
                                onClick={() => setListId?.(PSEUDO_ALL_LIST_ID)}
                            >
                                All
                            </div>
                        </SwiperSlide>

                        {/* Backend lists */}
                        {navArr.map((navItem: any, key: number) => {
                            const isActive = navItem?.id === listId

                            return (
                                <SwiperSlide
                                    key={navItem?.id ?? key}
                                    style={{ width: 'auto' }}
                                >
                                    <div
                                        tabIndex={0}
                                        role="button"
                                        className={`navbar__link navbar--${type}__link--${
                                            isActive ? 'active' : 'inactive'
                                        }`}
                                        onClick={() => setListId?.(navItem.id)}
                                    >
                                        {navItem.name}
                                    </div>
                                </SwiperSlide>
                            )
                        })}
                    </>
                )}
            </Swiper>

            {showManageFeed && (
                <ManageFeedButton
                    onApply={onApply}
                    chosenListId={chosenListId}
                />
            )}
        </div>
    )
}

export default NavigationBar
